import { notification } from "antd";
import { publicAPI, privateAPI, attachToken } from "../../Config/Constant";
import store from "../store";

export const createTemplate = async (paylaod) => {
  try {
    await attachToken();
    const res = await privateAPI.post("/message/create", paylaod);
    if (res) {
      let newpaylaod = {
        organizationid: paylaod.organizationid,
        page: 1,
      };
      await getTemplate(newpaylaod);

      return res;
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};

export const deleteTemplate = async (paylaod) => {
  try {
    await attachToken();
    const res = await privateAPI.delete(`/message/${paylaod.id}`);
    if (res) {
      if (paylaod.organizationid) {
        await getTemplate({ organizationid: paylaod.organizationid, page: 1 });
      }
      return res;
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};

export const getTemplate = async (paylaod) => {
  try {
    const res = await publicAPI.get(
      `/message/get/${paylaod.organizationid}?page=payload.page`
    );

    if (res) {


      if (res) {
        store.dispatch({
          type: "SET_ALL_TEMPLATE",
          payload: res.data.data,
        });

        return res;
        // }
      }
    }
  } catch (err) {
    //    console.error('Error during login:', err);
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};
